import React from 'react';
import { FormattedMessage } from 'react-intl';

import { blogifyErrorMessage } from '@confluence/publish-page-as-blog/entry-points/errors.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export type PublishAsBlogFailureFlagProps = {
	flags?: FlagsStateContainer;
	attributes?: { error?: string };
	customFlagMessage?: { title: any; description: any } | null;
};

export const publishPageAsBlogFailureFlag = ({
	flags,
	attributes,
	customFlagMessage,
}: PublishAsBlogFailureFlagProps): void => {
	flags &&
		void flags.showErrorFlag({
			title:
				customFlagMessage && customFlagMessage.title ? (
					customFlagMessage.title
				) : (
					<FormattedMessage {...blogifyErrorMessage(attributes?.error).title} />
				),
			description:
				customFlagMessage && customFlagMessage.description ? (
					customFlagMessage.description
				) : (
					<FormattedMessage {...blogifyErrorMessage(attributes?.error).description} />
				),
		});
};
